import { Navigate, Outlet } from 'react-router'
import { type UserRole, useRole } from '@/auth/useRole'
import { PageNote } from '@/components/PageNote'

/** Home route for a role: founders live in the portal, everyone else lands on `/`. */
function roleHome(role: UserRole | null): string {
  return role === 'founder' ? '/founder' : '/'
}

/**
 * Route guard: the current user's role must be in `allow`, else they are sent to
 * their own home (no dead ends — founders bounce to `/founder`, team/admin to `/`).
 *
 * UX only: the API enforces RBAC with 403. This just keeps users out of sections
 * they can't use. Assumes an authenticated session (mount inside <RequireAuth>).
 */
export function RequireRole({ allow }: { allow: UserRole[] }) {
  const { role, loading } = useRole()

  if (loading) {
    return (
      <main className="flex min-h-svh items-center justify-center">
        <PageNote>Bezig met laden…</PageNote>
      </main>
    )
  }

  if (role === null || !allow.includes(role)) {
    return <Navigate to={roleHome(role)} replace />
  }

  return <Outlet />
}
